import { motion, useReducedMotion } from "framer-motion";

/**
 * Reveal — restrained, fast scroll-entrance wrapper (fade + 16px slide-up).
 * Fires once when the element enters the viewport. Respects
 * prefers-reduced-motion by skipping the animation entirely.
 */
export function Reveal({ children, delay = 0, className = "" }) {
    const reduceMotion = useReducedMotion();
    if (reduceMotion) return <div className={className}>{children}</div>;

    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.4, delay, ease: [0.16, 1, 0.3, 1] }}
        >
            {children}
        </motion.div>
    );
}
